import React, { useState, useEffect } from "react";
import * as MUIStyled from "../../../MUIStyled";
import * as Styled from "../../../CompanyForm.styled";
import { ButtonText } from "../../elements/Buttons/Buttons.js";
import {
    buildContactTypeLabels,
    getContactTypeTags,
} from "../../../utils/contactTypeUtils";
import { formatReviewAddress } from "../../../utils/addressUtils";

export const DynamicReviewSection = ({
    title,
    tradingAddress,
    postalAddress,
    contactInfo,
    contactTypes,
    onEdit,
    areButtonsDisabled,
}) => {
    const [newContactInfo, setNewContactInfo] = useState([]);
    const contactTypeLabels = buildContactTypeLabels(contactTypes);

    useEffect(() => {
        setNewContactInfo(contactInfo);
    }, [contactInfo]);

    const renderContactTypeTags = (contact) => {
        return getContactTypeTags(contact, contactTypeLabels).map(
            ({ typeId, isPrimary, label }) => (
                <Styled.ContactTypeTag
                    key={typeId}
                    isPrimary={isPrimary}>
                    {label}
                </Styled.ContactTypeTag>
            )
        );
    };

    const renderAddress = () => {
        return (
            <>
                <Styled.DynamicSectionInnerBox>
                    <Styled.BodyText
                        style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        Trading Address
                    </Styled.BodyText>
                    <Styled.BodyText
                        style={{
                            fontSize: "16px",
                            fontWeight: "400",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        {formatReviewAddress(tradingAddress)}
                    </Styled.BodyText>
                </Styled.DynamicSectionInnerBox>
                <Styled.DynamicSectionInnerBox style={{ marginTop: "30px" }}>
                    <Styled.BodyText
                        style={{
                            fontSize: "18px",
                            fontWeight: "600",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        Postal Address
                    </Styled.BodyText>
                    <Styled.BodyText
                        style={{
                            fontSize: "16px",
                            fontWeight: "400",
                            textAlign: "left",
                            lineHeight: "1",
                        }}>
                        {formatReviewAddress(postalAddress)}
                    </Styled.BodyText>
                </Styled.DynamicSectionInnerBox>
            </>
        );
    };

    const renderContact = () => {
        return (
            <>
                {newContactInfo && newContactInfo.length > 0 ? (
                    newContactInfo?.map((contact) => (
                        <Styled.DynamicSectionInnerBox
                            key={contact.id}
                            style={{ marginTop: "30px" }}>
                            <Styled.ContactNameTagsWrapper>
                                <Styled.BodyText
                                    style={{
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        textAlign: "left",
                                        lineHeight: "1",
                                        margin: "0",
                                    }}>
                                    {contact.name} {contact.lastname}
                                </Styled.BodyText>
                                <Styled.ContactTagsContainer>
                                    {renderContactTypeTags(contact)}
                                </Styled.ContactTagsContainer>
                            </Styled.ContactNameTagsWrapper>

                            <Styled.BodyText
                                style={{
                                    fontSize: "16px",
                                    fontWeight: "400",
                                    textAlign: "left",
                                    lineHeight: "1",
                                }}>
                                {contact.phone?.trim()} - {contact.email}{" "}
                                {contact.title && `- ${contact.title}`}
                            </Styled.BodyText>
                        </Styled.DynamicSectionInnerBox>
                    ))
                ) : (
                    <Styled.BodyText>No contacts available.</Styled.BodyText>
                )}
            </>
        );
    };

    return (
        <Styled.DynamicMainWrapper style={{ margin: "0 0 30px 0" }}>
            {title && (
                <Styled.ReviewTitleBox style={{ margin: "0 0 30px 0" }}>
                    <Styled.DialogBoxTitle>{title}</Styled.DialogBoxTitle>
                    {!areButtonsDisabled && (
                        <ButtonText onClick={onEdit}>Edit</ButtonText>
                    )}
                </Styled.ReviewTitleBox>
            )}

            {tradingAddress && postalAddress && (
                <MUIStyled.CustomGrid
                    container
                    spacing={2}
                    direction="column">
                    <MUIStyled.CustomGrid
                        item
                        xs={12}
                        sm={6}>
                        <Styled.DynamicSectionMainBox>
                            {renderAddress()}
                        </Styled.DynamicSectionMainBox>
                    </MUIStyled.CustomGrid>
                </MUIStyled.CustomGrid>
            )}

            {newContactInfo && (
                <MUIStyled.CustomGrid
                    container
                    spacing={2}
                    direction="column">
                    <MUIStyled.CustomGrid
                        item
                        xs={12}
                        sm={6}>
                        <Styled.DynamicSectionMainBox>
                            {renderContact()}
                        </Styled.DynamicSectionMainBox>
                    </MUIStyled.CustomGrid>
                </MUIStyled.CustomGrid>
            )}
        </Styled.DynamicMainWrapper>
    );
};
